var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoLetterK = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 234"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A6AEAD",
  d: "m73.12 76.868 34.527 34.799h-28.81l-33.22-34.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C41DFF",
  d: "m73.12 76.868 34.527-29.442V21L73.121 50.442z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M25 38.557v73.065h20.617V21z"
})));
export { SvgLogoLetterK as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIwIDIzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03My4xMjA2IDc2Ljg2NzdMMTA3LjY0NyAxMTEuNjY3SDc4LjgzNzVMNDUuNjE2NyA3Ni44Njc3IiBmaWxsPSIjQTZBRUFEIi8+CiAgICA8cGF0aCBkPSJNNzMuMTIwNiA3Ni44Njc2TDEwNy42NDcgNDcuNDI1N1YyMUw3My4xMjA2IDUwLjQ0MTlWNzYuODY3NloiIGZpbGw9IiNDNDFERkYiLz4KICAgIDxwYXRoIGQ9Ik0yNSAzOC41NTcxVjExMS42MjJIMjUuMjI1MUg0NS4zOTE2SDQ1LjYxNjdWMjFMMjUgMzguNTU3MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";